import _ from 'lodash';

import Entity from './Entity';


const feeEntityFieldsWithDynamicAllowedValues = {
  type: { enumName: 'FeeTypeEnum' },
  payment_timing: { enumName: 'PaymentTypeEnum' }
};


export default class Fee {
  constructor(type = null) {
    this.fields.type.value = type;
  }

  fields = {
    id: {
      value: null
    },
    type: {
      value: null
    },
    price: {
      value: null
    },
    tax_1: {
      value: null
    },
    tax_2: {
      value: null
    },
    tax_3: {
      value: null
    },
    tax_4: {
      value: null
    },
    name: {
      value: null
    },
    percentage: {
      value: null
    },
    gross_price: {
      value: null
    },
    payment_timing: {
      value: null
    },
    payment_day: {
      value: null
    },
    start_date: {
      value: new Date()
    },
    display_name: {
      value: null
    },
    created_at: {
      value: null
    },
    updated_at: {
      value: null
    }
  };


  static createFromQueryValues(values) {
    const fee = new this();
    for (let field in fee.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'payment_day':
          case 'start_date':
          case 'created_at':
          case 'updated_at':
            fee.fields[field].value = (values[field] === null) ?
              values[field] :
              new Date(isNaN(Number(values[field])) ? values[field] : Number(values[field]));
            break;
          default:
            fee.fields[field].value = values[field];
        }
      }
    }

    return fee;
  }


  static getFieldAllowedValues(fields) {
    return Entity.getFieldAllowedValues(
      {},
      feeEntityFieldsWithDynamicAllowedValues,
      fields
    );
  }


  getQueryFieldValues() {
    if (this.fields.id.value === null &&
      this.fields.price.value === null &&
      this.fields.tax_1.value === null &&
      this.fields.tax_2.value === null &&
      this.fields.tax_3.value === null &&
      this.fields.tax_4.value === null &&
      this.fields.payment_timing.value === null &&
      this.fields.payment_day.value === null &&
      this.fields.start_date.value === null
    ) {
      return false;
    }

    const values = _.cloneDeep(FeeInput);

    for (let field in values) {
      switch (field) {
        case 'id':
          if (this.fields[field].value === null) {
            delete values.id;
          }
          else {
            values[field] = this.fields[field].value;
          }
          break;
        case 'price':
        case 'tax_1':
        case 'tax_2':
        case 'tax_3':
        case 'tax_4':
          values[field] = (this.fields[field].value === null) ? 0 : this.fields[field].value;
          break;
        case 'start_date': // @CMN Ask Craig if we can remove this...
          const value = this.fields[field].value;
          if (value !== null) {
            const valueYear = value.getUTCFullYear();
            const valueMonth = (value.getUTCMonth() + 1);
            const valueDate = value.getUTCDate();
            const valueString = `${valueYear}-${valueMonth}-${valueDate}`;
            values[field] = valueString;
          }
          break;
        default:
          if (this.fields[field].value !== null) {
            values[field] = (this.fields[field].value === '') ? null : this.fields[field].value;
          }
      }
    }

    return values;
  }


  updateGrossPrice() {
    this.fields.gross_price.value = parseInt(
      this.fields.price.value +
      this.fields.tax_1.value +
      this.fields.tax_2.value +
      this.fields.tax_3.value +
      this.fields.tax_4.value
    );
  }


  validate() {
    const startDate = this.fields.start_date.value;
    const type = this.fields.type.value;
    if(startDate === null && this.fields.gross_price.value !== null) {
      return { valid: false, error: `${type} fee must have a start date`}
    }

    return { valid: true }
  }
}


export const FeeInput = {
  id: null,
  type: null,
  price: null,
  tax_1: null,
  tax_2: null,
  tax_3: null,
  tax_4: null,
  percentage: null,
  payment_timing: null,
  payment_day: null,
  start_date: null
}

export const FeeMetaInput = {
  id: null, 
  type: null,
  price: null,
  tax_1: null,
  tax_2: null,
  tax_3: null,
  tax_4: null
}

export class FeeMeta {
  fields = {
    id: {
      value: null
    },
    type: {
      value: null
    },
    price: {
      value: null
    },
    tax_1: {
      value: null
    },
    tax_2: {
      value: null
    },
    tax_3: {
      value: null
    },
    tax_4: {
      value: null
    },
    name: {
      value: null,
    }
  };


  static createFromQueryValues(values) {
    const feeMeta = new this();

    for (let field in feeMeta.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          default:
            feeMeta.fields[field].value = values[field];
        }
      }
    }

    return feeMeta;
  }

  getLineItemFeeMetaValues() {
    const FeeMetaInput2 = {
      id: null, 
      type: null,
      price: null,
      tax_1: null,
      tax_2: null,
      tax_3: null,
      tax_4: null,
      name: null,
    }

    const feeMeta = _.cloneDeep(FeeMetaInput2);
    for (let field in feeMeta) {
      feeMeta[field] = this.fields[field].value;
    }

    return feeMeta;
  }
}
